<template lang="pug">
v-text-field(
    v-bind="$attrs"
    v-on="$listeners"
    :rules="accountIdentifierRules"
    label='Account Identifier'
    data-track="account-identifier"
    dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputAccountIdentifier extends Vue {
  accountIdentifierRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Account Identifier is required'];
}
</script>
